import { dataHeteronymSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHeteronymSquare = /*#__PURE__*/createIcon(dataHeteronymSquare)
export default IconHeteronymSquare
